import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ConnectedDesktopThermostatFilter } from './components';
import { ConnectedMobileThermostatFilter } from './components';
import './ThermostatStatus.css';
import { ConnectedThermostatsDisplay } from './components';
import { SearchBar } from '../SearchBar';
import { ThermostatActions, NetworkActions } from '../../store';
import { Spinner } from '../Spinner';

export class ThermostatStatus extends Component {
  state = { isModalOpen: false };

  componentDidMount() {
    const {
      selectedBuilding,
      setThermostats,
      selectedSubCategory: { id },
    } = this.props;
    setThermostats(selectedBuilding.slug, id);
  }

  componentWillUnmount() {
    this.props.clearLastRequest();
  }

  onChange = (e) => {
    const searchValue = e.target.value;
    this.props.updateFilters({ searchValue });
  };

  handleClick = () => {
    this.setState((state) => ({
      ...state,
      isModalOpen: true,
    }));
  };

  handleClose = () => {
    this.setState((state) => ({
      ...state,
      isModalOpen: false,
    }));
  };

  render() {
    const {
      allThermostatsCount,
      numberOfFilters,
      thermostatFilters,
      loading,
      error,
      selectedBuilding,
      filteredThermostatCount,
    } = this.props;
    const building = selectedBuilding.name;

    return (
      <div className="thermostat-status-display-box">
        <div className="thermostat-status-header">
          <span className="thermostat-status-header__title thermostat-status-header__title--desktop">
            {`${building}`}
          </span>
        </div>
        <div className="thermostat-status-main">
          <div className="thermostat-status__filter-desktop">
            <ConnectedDesktopThermostatFilter />
          </div>
          <div className="thermostat-status__filter-mobile">
            <button onClick={() => this.handleClick()} className="thermostat-filter__main-button">
              Select Filters {numberOfFilters > 0 ? `(${numberOfFilters})` : null}
            </button>
          </div>
          {this.state.isModalOpen ? <ConnectedMobileThermostatFilter onClose={this.handleClose} /> : null}
          <div className="thermostat-status__content">
            <div className="thermostat-status__content-header">
              <span className="thermostats-status__search">
                <SearchBar
                  value={thermostatFilters.searchValue}
                  placeholderText="Search by suite number"
                  onChange={this.onChange}
                />
              </span>
              <span className="thermostat-status__content-header-group">
                <span className="thermostat-status__content-header-item">
                  Thermostats:
                  <br />
                  <span className="thermostat-status__content-header-value">
                    {filteredThermostatCount} / {allThermostatsCount}
                  </span>
                </span>
              </span>
            </div>
            {error ? <div className="thermostat-status__error">{error}</div> : null}
            {loading ? (
              <div className="thermostat-status__loading-thermostats">
                <Spinner />
              </div>
            ) : (
              <ConnectedThermostatsDisplay />
            )}
          </div>
        </div>
      </div>
    );
  }
}

ThermostatStatus.propTypes = {
  allThermostatsCount: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  setThermostats: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  numberOfFilters: PropTypes.number.isRequired,
  filteredThermostatCount: PropTypes.number.isRequired,
  thermostatFilters: PropTypes.shape({
    connection_state: PropTypes.shape({
      online: PropTypes.bool,
      off: PropTypes.bool,
      offline: PropTypes.bool,
    }).isRequired,
    demand: PropTypes.shape({
      is_occupied: PropTypes.bool,
      is_fan_running: PropTypes.bool,
    }).isRequired,
    direction: PropTypes.shape({
      north: PropTypes.bool,
      north_east: PropTypes.bool,
      north_west: PropTypes.bool,
      west: PropTypes.bool,
      east: PropTypes.bool,
      south_east: PropTypes.bool,
      south_west: PropTypes.bool,
      south: PropTypes.bool,
    }),
    fan_mode: PropTypes.shape({
      auto: PropTypes.bool,
      off: PropTypes.bool,
      on: PropTypes.bool,
    }),
    building_section: PropTypes.shape({
      bottom: PropTypes.bool,
      middle: PropTypes.bool,
      top: PropTypes.bool,
    }),
    mode: PropTypes.shape({
      auto: PropTypes.bool,
      auxHeatOnly: PropTypes.bool,
      cool: PropTypes.bool,
      eco: PropTypes.bool,
      heat: PropTypes.bool,
      heat_cool: PropTypes.bool,
      off: PropTypes.bool,
    }),
    searchValue: PropTypes.string.isRequired,
    state: PropTypes.shape({
      aux_heat: PropTypes.bool,
      cool: PropTypes.bool,
      heat: PropTypes.bool,
      off: PropTypes.bool,
    }),
  }).isRequired,
  selectedBuilding: PropTypes.shape({
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    age: PropTypes.number,
    baseline_end_datetime: PropTypes.string,
    baseline_start_datetime: PropTypes.string,
    city: PropTypes.shape({
      alternate_names: PropTypes.string,
      country: PropTypes.number,
      display_name: PropTypes.string,
      feature_code: PropTypes.number,
      geoname_id: PropTypes.number,
      id: PropTypes.number,
      latitude: PropTypes.number,
      longitude: PropTypes.number,
      name: PropTypes.string,
      name_ascii: PropTypes.string,
      population: PropTypes.number,
      region: PropTypes.number,
      search_names: PropTypes.string,
      slug: PropTypes.string,
      timezone: PropTypes.string,
    }),
    country: PropTypes.shape({
      alternate_names: PropTypes.string,
      code2: PropTypes.number,
      code3: PropTypes.number,
      continent: PropTypes.string,
      geoname_id: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string,
      name_ascii: PropTypes.string,
      phone: PropTypes.number,
      slug: PropTypes.string,
      tld: PropTypes.string,
    }),
    fiscal_year_end_day: PropTypes.number,
    fiscal_year_end_month: PropTypes.number,
    fiscal_year_start_day: PropTypes.number,
    fiscal_year_start_month: PropTypes.number,
    id: PropTypes.number,
    image: PropTypes.string,
    name: PropTypes.string,
    number_of_floors: PropTypes.number,
    number_of_units: PropTypes.number,
    postal_code: PropTypes.string,
    province: PropTypes.shape({
      alternate_names: PropTypes.string,
      country: PropTypes.number,
      display_name: PropTypes.string,
      geoname_code: PropTypes.number,
      geoname_id: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string,
      name_ascii: PropTypes.string,
      slug: PropTypes.string,
    }),
    reporting_start_datetime: PropTypes.string,
    slug: PropTypes.string,
    utilities: PropTypes.array,
  }).isRequired,
  selectedSubCategory: PropTypes.shape({
    api_location: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
};

ThermostatStatus.defaultProps = { error: undefined };

function mapStateToProps(state) {
  return {
    allThermostatsCount: state.thermostatReducer.allThermostatsCount,
    error: state.thermostatReducer.error,
    numberOfFilters: state.thermostatReducer.numberOfFilters,
    filteredThermostatCount: state.thermostatReducer.filteredThermostatCount,
    thermostatFilters: state.thermostatReducer.thermostatFilters,
    selectedBuilding: state.buildingReducer.selectedBuilding,
    loading: state.thermostatReducer.isFetching,
    selectedSubCategory: state.buildingReducer.selectedSubCategory,
  };
}

const mapDispatchToProps = {
  updateFilters: ThermostatActions.updateFilters,
  setThermostats: ThermostatActions.setThermostats,
  clearLastRequest: NetworkActions.clearLastRequest,
};

const ConnectedThermostatStatus = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ThermostatStatus);
export { ConnectedThermostatStatus };
